import { inject, Injectable } from '@angular/core';
import { UserService } from '@app/user';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { BehaviorSubject } from 'rxjs';
import { AdminItem } from '../components/nav-item-admin-list/models';
import { navItemsAccessFilter } from '@app/shell/header/utils';
import { AccessibilityService } from '@app/tw-shared/services';

@Injectable({
    providedIn: 'root',
})
export class AdminSettingsNavItemsService {
    private readonly userService = inject(UserService);
    private readonly accessibilityService = inject(AccessibilityService);

    readonly isVeryLargeFontSize$ = this.accessibilityService.isVeryLargeFontSize$;

    readonly items$ = new BehaviorSubject<AdminItem[]>([
        {
            name: marker('v3-header-item-title'),
            route: ['/manager', 'analysis'],
            access: (user) => !user.company.trial && this.userService.access.includes('manager-analysis'),
            icon: 'arrow-graph-up',
        },
        {
            name: marker('v3-global-organisation'),
            route: ['/manager/settings/company'],
            access: (user) => this.userService.access.includes('manager-settings-company') && !user.company.trial,
            icon: 'organisation',
        },
        {
            name: marker('v3-global-users'),
            route: ['/manager/settings/users'],
            access: (user) => {
                return (
                    (this.userService.access.includes('manager-settings-users') ||
                        this.userService.access.includes('manager-settings-content-builder') ||
                        this.userService.access.includes('manager-settings-content-builder-restricted')) &&
                    !user.company.trial
                );
            },
            icon: 'people',
        },
        {
            name: marker('v3-global-content'),
            route: ['/manager/settings/content'],
            access: (user) => {
                return (
                    ((!(!user.roles.includes('company_admin') && user.roles.includes('advisor') && !user.roles.includes('manager')) &&
                        (this.userService.access.includes('manager-settings-content-builder') ||
                            this.userService.access.includes('manager-settings-content-builder-restricted'))) ||
                        this.userService.access.includes('manager-settings-content-builder-advisor') ||
                        this.userService.access.includes('manager-byoc')) &&
                    this.userService.access.includes('manager-content-settings-access') &&
                    !user.company.trial
                );
            },
            icon: 'video',
        },
        {
            name: marker('v3-global-alter-company'),
            route: ['/manager/settings/alter'],
            access: (user) => this.userService.access.includes('manager-settings-alter-company') && !user.company.trial,
            icon: 'alter-company',
        },
        {
            name: marker('v3-manager-settings-audit-logs-title'),
            route: ['/manager/settings/audit-logs'],
            access: (user) => this.userService.access.includes('manager-settings-audit-logs') && !user.company.trial,
            icon: 'audit-logs',
        },
    ]).pipe(navItemsAccessFilter(this.userService));
}
